import { render, staticRenderFns } from "./myBrowsingHistory.vue?vue&type=template&id=34fc0bd5&scoped=true&"
import script from "./myBrowsingHistory.vue?vue&type=script&lang=js&"
export * from "./myBrowsingHistory.vue?vue&type=script&lang=js&"
import style0 from "./myBrowsingHistory.vue?vue&type=style&index=0&id=34fc0bd5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc0bd5",
  null
  
)

export default component.exports